import { themes } from '../../services/bff.api';

export const ADMIN_OFFERING_THEMES_RESOURCE = {
  key: 'ADMIN_OFFERING_THEMES_RESOURCE',
  table: {
    title: 'Labels',
    defaultSort: 'name',
    dataLocation: '_embedded.themes',
    searchParams: ['name'],
    fields: [{ value: 'name', label: 'Naam', show: true, order: 0 }],
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i
      }))
  },
  api: {
    get: themes.search
  }
};
